import { useEffect, useState } from "react";
import { api, money } from "../../api";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/api/admin/customers");
        setCustomers(data);
      } catch {}
      setLoading(false);
    })();
  }, []);

  return (
    <div className="admin-page">
      <div className="admin-page-head">
        <div>
          <span className="eyebrow">People</span>
          <h1>Customers.</h1>
        </div>
      </div>
      {loading ? (
        <p className="empty-state">Loading…</p>
      ) : customers.length ? (
        <div className="admin-table" data-testid="admin-customers-table">
          <div className="admin-table-head admin-customers-head">
            <span>Name</span>
            <span>Email</span>
            <span>Phone</span>
            <span>Orders</span>
            <span>Joined</span>
          </div>
          {customers.map((c) => (
            <div className="admin-table-row admin-customers-row" key={c.id} data-testid={`admin-customer-row-${c.id}`}>
              <strong>{c.name}</strong>
              <span>{c.email}</span>
              <span>{c.phone || "—"}</span>
              <span>{c.order_count}</span>
              <span>{c.created_at ? new Date(c.created_at).toLocaleDateString() : "—"}</span>
            </div>
          ))}
        </div>
      ) : (
        <p className="empty-state">No customers yet. Registered accounts will appear here.</p>
      )}
    </div>
  );
}
